export default __webpack_public_path__ + "static/media/invite.39ae1460.svg";